import type { AxiosError, AxiosInstance, InternalAxiosRequestConfig } from 'axios'

interface HttpAuthAdapter {
  getAccessToken(): string | null
  refreshAccessToken(): Promise<string | null>
  onSessionExpired(): void
}

let adapter: HttpAuthAdapter | null = null
let refreshPromise: Promise<string | null> | null = null

export function configureHttpAuth(nextAdapter: HttpAuthAdapter): void {
  adapter = nextAdapter
}

export function attachAuthInterceptors(client: AxiosInstance): void {
  client.interceptors.request.use((config) => {
    const token = adapter?.getAccessToken()
    if (token) config.headers.Authorization = `Bearer ${token}`
    return config
  })

  client.interceptors.response.use(undefined, async (error: AxiosError) => {
    const request = error.config as (InternalAxiosRequestConfig & { _retried?: boolean }) | undefined
    if (!adapter || error.response?.status !== 401 || !request || request._retried) throw error
    request._retried = true
    refreshPromise ??= adapter.refreshAccessToken().finally(() => { refreshPromise = null })
    const token = await refreshPromise
    if (!token) {
      adapter.onSessionExpired()
      throw error
    }
    request.headers.Authorization = `Bearer ${token}`
    return client(request)
  })
}
